// 1 for links
// 0 for button

import React, { useEffect } from "react";
import styled, { css, useTheme } from "styled-components";
import { Link } from "react-router-dom";
import { useDetectClickOutside } from "react-detect-click-outside";

const Dropdown = (props) => {
  const theme = useTheme();
  useEffect(() => {
    isvisible();
    window.addEventListener("scroll", function () {
      isvisible();
    });
  });

  const refs = useDetectClickOutside({
    onTriggered: handleClickOut,
    triggerKeys: ["Escape"],
  });
  function handleClickOut(e) {
    props.setShow(false);
  }
  return (
    <>
      {props.show && (
        <Menu
          onClick={(e) => {
            e.stopPropagation();
          }}
          ref={refs}
          style={{
            ...{
              margin: props.margin,
              width: props.width,
              backgroundColor: props.isVideoPlayer ? "rgb(24, 25, 26)" : theme.color.background,
              border: "1px solid" + props.isVideoPlayer ? "rgb(38, 38, 38)" : theme.color.border,
            },
            ...props.style,
          }}
          id="menu"
        >
          {props.options.map(function (object, i) {
            if (object.type === 2 || object.type === 4 || object.type === 3) {
              return (
                <Btn
                  selected={object.selected}
                  isVideoPlayer={props.isVideoPlayer}
                  className={object.disable ? "disable" : ""}
                  style={{ Item }}
                  key={i}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    object.func();
                  }}
                >
                  {object.icon && (
                    <img
                      style={{
                        width: object.title === "Back" ? "9px" : "",
                        height: object.title === "Back" ? "9px" : "",
                      }}
                      className="img"
                      alt={object.title}
                      src={object.icon}
                    />
                  )}
                  {object.title}
                </Btn>
              );
            }
            return (
              <ItemLink
                style={{ Item }}
                key={i}
                to={object.link}
                alt={object.title}
                onClick={() => {
                  props.setShow(false);
                }}
              >
                <Section>
                  {object.icon && <img alt={object.title} src={object.icon} />}
                  {object.title}
                </Section>
              </ItemLink>
            );
          })}
        </Menu>
      )}
    </>
  );
};
export default Dropdown;

const isvisible = () => {
  const element = document.getElementById("menu");
  if (element) {
    var position = element.getBoundingClientRect();
    if (position.right > window.innerWidth) {
      element.style.right = window.innerWidth - position.right + "px";
    }
  }
};

const Menu = styled.div`
  display: flex;
  height: auto;
  min-width: 100px;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  position: absolute;
  z-index: 10;

  @media only screen and (max-width: 576px) {
    border-radius: 13px 13px 0px 0px;
    min-height: 28vh;
    position: fixed;
    top: unset !important;
    bottom: 0 !important;
    left: 0 !important;
    margin: 0 !important;
    transform: translate(0, 0) !important;
    min-width: 100%;
    width: 100%;
    padding: 6px 14px;
    font-size: 10px;
    line-height: 10px;
    padding: 0;
  }
`;
const Item_scss = css`
  padding: 10px 14px;
  white-space: nowrap;
  background: transparent;
  letter-spacing: 0.045em;
  font-family: "Poppins Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: ${({ theme }) => theme.color.primaryText};

  cursor: pointer;
  text-decoration: none;
  outline: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: all 200ms;

  @media only screen and (max-width: 576px) {
    padding: 20px 15px;
    font-size: 10px;
    line-height: 10px;
  }
  &:hover {
    background: ${({ theme }) => theme.color.secondaryBg};
    color: ${({ theme }) => theme.color.primary};

    img {
      filter: invert(44%) sepia(46%) saturate(5896%) hue-rotate(217deg) brightness(98%)
        contrast(106%);
    }
  }
  img {
    width: 13px;
    height: 13px;
    margin-right: 13px;
    object-fit: contain;
  }

  ${({ isVideoPlayer }) =>
    isVideoPlayer === true &&
    `
    padding: 7px 14px;
   color: #F2F5FF;
  &:hover  {
    background-color: #202020 ;
    color: #4569FF;

    img {
      filter: invert(44%) sepia(46%) saturate(5896%) hue-rotate(217deg) brightness(98%)
        contrast(106%);
    }
  }

  img {
    width: 8px;
    height: 8px;
    margin-right: 10px;
    object-fit: contain;
  }
  `};
  ${({ selected }) =>
    selected &&
    `
    color: #4569FF;

    img {
      filter: invert(44%) sepia(46%) saturate(5896%) hue-rotate(217deg) brightness(98%)
        contrast(106%);
    }

  `}
`;
const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Item = styled.div`
  ${Item_scss}
`;
const ItemLink = styled(Link)`
  ${Item_scss}
`;

const Btn = styled.button`
  ${Item_scss}

  &.disable {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }
`;
